import { createSelector } from 'reselect';

export const getPreLoginEmail = (state) => state.authReducer.preLoginEmail;
export const getSSOConfig = (state) => state.authReducer.ssoConfig;
export const getOidcConfig = createSelector([getSSOConfig], (ssoConfig) => ssoConfig?.oidcConfig || null);
export const isSSOEnabled = createSelector([getSSOConfig], (ssoConfig) => ssoConfig?.enableSSO || null);
export const getAuthError = (state) => state.authReducer.authError;
